import { plans } from "@/config/stripePlans";

export const checkOutletLimit = (tier: string | null | undefined, currentOutlets: number): boolean => {
  const t = (tier || "free").toLowerCase();
  const plan = plans[t] || plans.free;

  const limit = plan.limits.outlets;

  if (limit === null) return true;

  return currentOutlets < limit;
};

export const checkStaffLimit = (tier: string | null | undefined, currentStaff: number): boolean => {
  const t = (tier || "free").toLowerCase();
  const plan = plans[t] || plans.free;

  const limit = plan.limits.staff;

  if (limit === null) return true;

  return currentStaff < limit;
};
